import React from 'react';
import { createConfirmation, type ConfirmableDialog } from 'react-confirm';
import ConfirmationDialog, { type ConfirmationDialogOwnProps } from '../ConfirmationDialog';

/**
 * Create a confirmation for deleting a project using react-confirm.
 *
 * `confirmable(ConfirmationDialog)` widens the dialog's caller-prop generic to
 * include react-confirm's injected `proceed`/`cancel`/`show` props, so
 * `createConfirmation` would otherwise demand them from the caller. Re-type the
 * wrapped component to its caller-facing prop shape (`ConfirmationDialogOwnProps`,
 * resolving `void`). Type-only cast at this library boundary; same convention as
 * Project/confirmation.tsx — runtime component is unchanged.
 */
const confirm = createConfirmation(
  ConfirmationDialog as unknown as ConfirmableDialog<ConfirmationDialogOwnProps, void>
);

/**
 * Utility function to show a confirmation dialog before discarding changes.
 *
 * @param name the name of the project shown in the confirmation copy.
 */
export default function confirmRemoveProject(name: string) {
  return confirm({
    confirmation: (
      <React.Fragment>
        <p>Are you sure you want to remove project &quot;{name}&quot;? There is no undo!</p>
      </React.Fragment>
    ),
    options: {
      title: 'Remove project?',
      proceedText: 'Remove project',
    },
  });
}
